<template>
  <app-layout title="Список магазинов">
    <div class="restriction" v-if="restricted">
      У Вас недостаточно прав для просмотра этой страницы
    </div>
    <div class="store" v-else>
      <div
        class="store__loader"
        v-if="loading">
        <v-progress-circular
          :size="70"
          :width="7"
          color="grey"
          indeterminate
        ></v-progress-circular>
      </div>

      <template v-else>
        <h2 class="header headline font-weight-medium">{{ currentStore.store.name }}</h2>

        <div class="store__info">
          <table class="store__info-table" ref="storeInfoTable">
            <tr>
              <th>Город</th>
              <td>{{ currentStore.store.city }}</td>
              <th>ТЦ</th>
              <td>{{ currentStore.store.mall }}</td>
            </tr>

            <tr>
              <th>Организация</th>
              <td>{{ currentStore.store.organisation }}</td>
              <th>Адрес</th>
              <td>{{ currentStore.store.address }}</td>
            </tr>

            <tr>
              <th>Код магазина</th>
              <td>{{ currentStore.store.code }}</td>
              <th>Время работы</th>
              <td>{{ currentStore.store.workTime }}</td>
            </tr>

            <tr>
              <th>Телефон</th>
              <td>{{ currentStore.store.phone }}</td>
              <th>E-mail</th>
              <td>{{ currentStore.store.email }}</td>
            </tr>
          </table>

          <a href="#" class="store__copy" @click.prevent="handleCopy">СКОПИРОВАТЬ ВСЮ ИНФОРМАЦИЮ</a>
        </div>

        <div class="statistic">
          <h3 class="subheader subheading font-weight-medium">Статистика</h3>

          <table class="statistic__table">
            <tr>
              <th>В магазине</th>
              <th>Ожидает забора</th>
              <th>В пути</th>
              <th>Получены</th>
              <th>Приняты</th>
            </tr>
            <tr>
              <td>{{ currentStore.ordersInShop }}</td>
              <td>{{ currentStore.ordersAwaitingFence }}</td>
              <td>{{ currentStore.ordersOnTheWay }}</td>
              <td>{{ currentStore.ordersReceived }}</td>
              <td>{{ currentStore.ordersAccepted }}</td>
            </tr>
          </table>
        </div>

        <div class="orders">
          <h3 class="subheader subheading font-weight-medium">Заявки на выкуп устройств</h3>

          <v-tabs>
            <v-tab
              v-for="tab in orderTypes"
              :key="tab.id"
              @click="handleTabChange(tab.id)"
              ripple
            >
              {{ tab.label }}
            </v-tab>

            <v-tab-item
              v-for="tab in orderTypes"
              :key="tab.id"
              :transition="false"
              :reverse-transition="false"
            >
              <v-data-table
                class="orders-table"
                v-model="selectedDevices"
                :headers="ordersTableHeaders"
                :items="orders[tab.id]"
                :sort-by="['btag', 'sn']"
                :sort-desc="[false, true]"
                multi-sort
                select-all
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        :input-value="selectedAll"
                        color="#0089D7"
                        primary
                        hide-details
                        @click.stop="toggleAllDevices"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template
                  slot="items"
                  slot-scope="{ item: { btag, sn, brand, price, date, days } }"
                >
                  <tr class="orders-table__row">
                    <td>
                      <v-checkbox
                        class="orders-table__checkbox"
                        color="#0089D7"
                        :input-value="selectedAll || selectedDevices.indexOf(btag) >= 0"
                        primary
                        hide-details
                        @change="handleDeviceSelect(btag)"
                      ></v-checkbox>
                    </td>
                    <td>{{ btag }}</td>
                    <td>{{ sn }}</td>
                    <td>{{ brand }}</td>
                    <td>{{ price }}</td>
                    <td>{{ date }}</td>
                    <td>{{ days }} дней</td>
                  </tr>
                </template>
                </v-data-table>
              <!-- <v-btn
                class="orders-table__download-button"
                color="info"
                :disabled="!(selectedAll || selectedDevices.length > 0)"
                :hidden="currentOrdersType!='inShop' && currentOrdersType!='awaitingFence' && currentOrdersType!='onTheWay'"
                @click="handleDocumentDownload();dialog = false"
                v-if="user && (user.name=='Костя' || user.name=='Паша')"
                v-on="on"
              >
                ДОКУМЕНТЫ
              </v-btn> -->
              <v-btn
                class="orders-table__download-button"
                color="info"
                :disabled="!(selectedAll || selectedDevices.length > 0)"
                @click="handleDocumentDownload"
                v-on="on"
              >
                ДОКУМЕНТЫ
              </v-btn>
              <!-- <v-btn
                class="orders-table__download-button"
                color="info"
                :disabled="!(selectedAll || selectedDevices.length > 0)"
                :hidden="currentOrdersType!='awaitingFence' && currentOrdersType!='received' && currentOrdersType!='onTheWay'"
                @click="handleToReceived"
                v-if="user && (user.name=='Костя' || user.name=='Паша')"
              >
                Приняты
              </v-btn> -->
              <v-btn
                class="orders-table__download-button"
                color="info"
                :disabled="!(selectedAll || selectedDevices.length > 0)"
                @click="handleToReceived"
              >
                Приняты
              </v-btn>
            </v-tab-item>
          </v-tabs>
        </div>
      </template>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import AppLayout from '../../components/AppLayout.vue';

export default {
  name: 'store',
  components: {
    AppLayout,
  },
  data() {
    return {
      id: Number(this.$route.params.id),
      currentOrdersType: 'inShop',
      orderTypes: [
        { id: 'inShop', label: 'В магазине' },
        { id: 'awaitingFence', label: 'Ожидает забора' },
        { id: 'onTheWay', label: 'В пути' },
        { id: 'received', label: 'Получены' },
        { id: 'accepted', label: 'Приняты' },
      ],
      ordersTableHeaders: [
        { text: 'BTAG', value: 'btag' },
        { text: 'SN/IMEI', value: 'sn' },
        { text: 'Устройство', value: 'brand' },
        { text: 'Стоимость', value: 'price' },
        { text: 'Дата', value: 'date' },
        { text: 'Срок хранения', value: 'days' },
      ],
      selectedDevices: [],
      pagination: {
        descending: false,
        sortBy: 'date',
      },
      dateFence: false
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('stores', ['loading', 'currentStore', 'orders']),
    ...mapGetters('stores', ['storeById']),
    restricted() {
      return this.user.type < 2;
    },
    selectedAll() {
      const orders = this.orders[this.currentOrdersType] || [];

      return this.selectedDevices.length > 0 && this.selectedDevices.length === orders.length;
    },
  },
  methods: {
    ...mapActions('stores', ['fetchStore', 'fetchOrdersByType', 'getDocumentURL','changeToReceivedURL']),

    toggleAllDevices() {
      if (this.selectedDevices.length) {
        this.selectedDevices = [];
      } else {
        this.selectedDevices = this.orders[this.currentOrdersType].map(order => order.btag);
      }
    },

    handleDeviceSelect(btag) {
      const index = this.selectedDevices.indexOf(btag);

      if (index >= 0) {
        this.selectedDevices.splice(index, 1);
      } else {
        this.selectedDevices.push(btag);
      }
    },

    handleCopy() {
      const el = this.$refs.storeInfoTable;
      const body = document.body;
      let range;
      let sel;

      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();

        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      } else if (body.createTextRange) {
        range = body.createTextRange();
        range.moveToElementText(el);
        range.select();
      }

      document.execCommand('Copy');

      if (window.getSelection) {
        if (window.getSelection().empty) {
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {
          window.getSelection().removeAllRanges();
        }
      } else if (document.selection) {
        document.selection.empty();
      }
    },

    handleTabChange(ordersType) {
      this.currentOrdersType = ordersType;
      this.fetchOrdersByType({
        id: this.id,
        ordersType,
      });
      if(this.currentOrdersType == 'inShop') this.toggleAllDevices()
    },

    handleDocumentDownload() {
      this.getDocumentURL(this.selectedDevices);
      this.selectedDevices = [];
      this.fetchOrdersByType({
        id: this.id,
        ordersType: this.currentOrdersType,
      });
    },
    handleToReceived() {
      this.changeToReceivedURL(this.selectedDevices);
      this.selectedDevices = [];
      this.fetchOrdersByType({
        id: this.id,
        ordersType: this.currentOrdersType,
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },

  async created() {
    await this.fetchStore(this.id);
    await this.fetchOrdersByType({
      id: this.id,
      ordersType: 'inShop',
    });
    if(this.currentOrdersType == 'inShop') this.toggleAllDevices()
  },
};
</script>

<style lang="sass">
  .restriction
    margin: auto

  .store
    display: flex
    flex-direction: column
    width: 100%
    min-height: 100%
    align-self: flex-start
    font-size: 14px
    line-height: 16px

    &__loader
      margin: auto

    .header
      margin-bottom: 30px

    .subheader
      margin-bottom: 10px
      font-size: 18px
      line-height: 21px

    &__info-table
      margin-bottom: 23px
      text-align: left

      tr th:first-child
        width: 96px !important

      tr th
        width: 106px

      th, td
        height: 36px

      th
        font-weight: 300
        color: rgba(0, 0, 0, 0.66)

      td
        font-weight: 500
        font-size: 18px
        line-height: 21px
        color: rgba(0, 0, 0, 0.87)

        &:nth-child(2n)
          padding-right: 60px

    &__copy
      display: inline-block
      margin-bottom: 59px
      font-weight: 500
      font-size: 14px
      line-height: 16px
      color: rgba(0, 0, 0, 0.87)
      text-decoration: none

    .statistic
      margin-bottom: 50px

      &__table
        th
          padding-right: 45px
          color: rgba(0, 0, 0, 0.66)

        td
          height: 48px
          font-weight: bold
          font-size: 36px
          color: #178DE3

    .orders-table
      tfoot
        display: flex

      &__download-button
        margin: 20px

      &__checkbox
        vertical-align: middle
</style>
